import { NgModule, Provider } from '@angular/core';
import { checkDevEnvironment } from 'src/app/utils/environment/environment.utils';
import { environment } from 'src/environments/environment';
import { BlankDevService } from './blank-dev.service';
import { initDevServiceProvider } from './dev.interface';

function getProviders(): Provider[] {
  if (!checkDevEnvironment(environment)) {
    return []; // No mocking in production
  }

  return environment.devServiceProviders;
}

@NgModule({
  // TODO: Move this logic to webpack.
  // This is causing problems with the compilation of the app.
  // The environment constant is not defined until after this module is defined
  // which is causing the checkDevEnvironment function to throw an error.

  providers: getProviders().concat(
    initDevServiceProvider(BlankDevService) // Need at least one provider
  )
  // providers: [
    // initDevServiceProvider(BlankDevService)
  // ]
})
export class DevModule {}
